<template>
    <aside class="sidebar">
        <router-link to="/" class="sidebar-elem sidebar-logo">
            <img src="@/assets/images/sidebar/logo.svg" alt="">
        </router-link>
        <a v-if="showAwl" href="https://appswithlove.com/en/" class="sidebar-elem sidebar-awl" target="_blank" rel="noopener noreferrer">
            <img src="@/assets/images/sidebar/awl.svg" alt="">
        </a>
        <span
            v-if="showLogout"
            class="sidebar-elem sidebar-logout"
            @click="logoutClick()"
        >
            <img src="@/assets/images/sidebar/logout.svg" alt="">
        </span>
        <modal
            v-if="logout.open"
            :title="$t('components.sidebar.logout.title')"
            :message="$t('components.sidebar.logout.message')"
            :cancelShow="true"
            :confirmLabel="$t('components.sidebar.logout.button')"
            @cancel="logoutCancel"
            @confirm="logoutConfirm"
        />
    </aside>
</template>

<script>
import Modal from './Modal.vue';

export default {
    name: 'Sidebar',
    components: {
        Modal,
    },
    props: {
        showAwl: {
            type: Boolean,
            default: true,
        },
        showLogout: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            logout: {
                open: false,
            },
        };
    },
    methods: {
        logoutCancel() {
            this.logout.open = false;
        },
        logoutClick() {
            this.logout.open = true;
        },
        logoutConfirm() {
            this.$store.dispatch('auth/logout');
        },
    },
};
</script>
